var exports = {
  "kL": "container__VjYJjy",
  "R_": "heading__1zaZKI",
  "LW": "newRunnerButton__e6p29g",
  "CU": "learnMoreLink__L74dmb",
  "AJ": "learnMoreButton__B4najf",
};

module.exports = exports;
